import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import yuganthidoc from '../../../../assets/images/Doctorsimages/dr.yuganthi.png'
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const YuganthiDoc = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Dr. Yuganthi Durai | Best Dentist & Aesthetic Doctor in Chennai | Skin, Hair & Smile Specialist";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Yuganthi Durai (BDS, PGDMC, FFA, MMP), Senior Consultant Dentist & Aesthetic Doctor in Chennai with 2+ years of experience. Expert in smile designing, cosmetic dentistry, acne, pigmentation, hair fall, and facial aesthetics."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best dentist in Chennai, female dentist in Chennai, smile designing dentist in Chennai, cosmetic dentist in Chennai, aesthetic doctor for pigmentation in Chennai, acne treatment doctor in Chennai, trichology doctor for hair fall in Chennai, skin and hair specialist near me, facial aesthetics doctor in Chennai, best doctor for anti-aging treatment in Chennai, affordable dental treatment in Chennai, dentist and aesthetic consultant Chennai"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-yuganthi-durai-dentist-aesthetic-skin-hair-chennai");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-yuganthi-durai-dentist-aesthetic-skin-hair-chennai");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

     const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10;
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
  
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.YUGANTHI_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};
  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Yuganthi Durai</span>
                  <span className="veenadoc-title-credentials">(BDS, PGDMC, FFA, MMP)</span>
                  <span className="veenadoc-title-location">Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Senior Consultant in Dentistry, Medical Cosmetology & Facial Aesthetics with over <strong>2</strong> years of professional 
                    experience. Recognized as one of the best female dentists in Chennai and a trusted aesthetic doctor, 
                    known for her patient-centric approach that blends scientific precision with artistic care.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={yuganthidoc} alt="Dr. Yuganthi Durai – Senior Consultant Dentist & Aesthetic Doctor in Chennai" className="veenadoc-doctor-image" title='Dr. Yuganthi Durai | Best Dentist, Skin & Hair Specialist in Chennai' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Yuganthi Durai</h2>
                  <p>
                    Dr. Yuganthi Durai's academic journey began at the <strong>Chettinad Dental College and Research Institute</strong>, 
                    Kelambakkam, affiliated with <strong>Dr. M.G.R Tamil Nadu Medical University</strong>, Chennai, where she completed her 
                    B.D.S. degree. To advance her expertise, she pursued a Postgraduate Diploma in Medical Cosmetology, 
                    a Fellowship in Facial Aesthetics, a Master Course in Micropigmentation, and advanced certifications 
                    in Clinical Research, Pharmacovigilance, Clinical Data Management, and Medical Writing.
                  </p>
                  <p>
                    These qualifications allow her to provide an integrated approach to dentistry, skin care, and aesthetics, 
                    making her one of the most versatile specialists in Chennai.
                  </p>
                </div>

                {/* Clinical Experience */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Experience & Professional Journey</h2>
                  <p>
                    Over the years, she has practiced at reputed centers including The Madras Cosmetic Clinic, Padur and 
                    Mister Hair Clinic, Panaiyur, where she treated patients seeking high-quality dental, skin, and hair 
                    care solutions. Many patients searching for the best dentist in Chennai, cosmetic dentist near me, 
                    or aesthetic skin doctor in Tamil Nadu find her profile relevant because she offers a unique combination 
                    of dental expertise and aesthetic treatments under one roof.
                  </p>
                 
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BDS, PGDMC, FFA, MMP</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">2+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Dentistry, Cosmetology & Facial Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Chennai</span>
                    </div>
                  </div>
                </div>

                {/* Dentistry Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Excellence in Dentistry & Smile Designing</h2>
                  <p>
                    Her dentistry expertise includes preventive and restorative care, cosmetic fillings, root canal therapy, 
                    and smile designing. Patients looking for the best dentist for smile designing in Chennai or a female 
                    root canal specialist in Chennai often consult her because of her reputation for providing pain-free, 
                    precise, and lasting results.
                  </p>
                  <p>
                    She believes dentistry is not just about treating tooth problems but about improving overall oral health 
                    and boosting self-confidence through beautiful smiles.
                  </p>
                </div>

                {/* Aesthetic Medicine */}
                <div className="veenadoc-article-block">
                  <h2>Advanced Aesthetic & Cosmetic Treatments</h2>
                  <p>
                    As a cosmetic and facial aesthetics specialist in Chennai, Dr. Yuganthi offers advanced treatments such 
                    as pigmentation removal, acne and pimples treatment, scar correction, anti-aging therapies, chemical peels, 
                    skin rejuvenation, and micropigmentation. Patients searching for the best doctor for acne treatment in 
                    Chennai or an aesthetic doctor for pigmentation in Tamil Nadu trust her for safe, effective, and minimally 
                    invasive solutions.
                  </p>
                  <p>
                    Her fellowship in facial aesthetics and master training in micropigmentation further enhance her expertise, 
                    making her a go-to doctor for patients seeking natural results in cosmetic enhancements.
                  </p>
                </div>

                {/* Trichology Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Yuganthi has gained recognition as a trichology doctor in Chennai specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block">
                  <h2>Philosophy of Care</h2>
                  <p>
                    Her philosophy of care can be summed up in her own words: "For me every consultation is a conversation, 
                    every procedure is a promise. I approach aesthetics with empathy, safety and artistry to help each person 
                    bring out the strength and confidence they already carry within when they look in the mirror."
                  </p>
                  <p>
                    This reflects her dedication to creating a positive and empowering experience for every patient.
                  </p>
                </div>

                {/* Comprehensive Care */}
                <div className="veenadoc-article-block">
                  <h2>One-Stop Solution for Multiple Needs</h2>
                  <p>
                    Her wide range of services makes her a one-stop solution for patients with diverse needs. Whether it is 
                    restorative dentistry for tooth pain, smile designing for aesthetic confidence, acne and pigmentation 
                    treatment for clearer skin, or hair regrowth therapy for stronger hair, Dr. Yuganthi ensures holistic, 
                    safe, and result-driven solutions.
                  </p>
                  <p>
                    Patients appreciate her for combining dental science with medical cosmetology and trichology, offering 
                    them the convenience of multiple treatments in a single consultation.
                  </p>
                </div>

                {/* Patient Experience */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Reviews</h2>
                  <p>
                    Patients describe her as approachable, friendly, and highly skilled, with many reviews highlighting her 
                    ability to explain procedures clearly and deliver results that exceed expectations. She focuses on 
                    long-term solutions rather than quick fixes, earning her a reputation as one of the most trusted names 
                    in her field.
                  </p>
                  <p>
                    By staying updated with the latest advancements in dentistry, cosmetology, and hair care, Dr. Yuganthi 
                    ensures her patients always receive modern, evidence-based treatments.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Yuganthi Durai for Complete Care</h2>
                  <p>
                    Choosing Dr. Yuganthi Durai means selecting a doctor who not only treats conditions but also enhances 
                    overall confidence and quality of life. For patients searching for the best dentist in Chennai, a 
                    cosmetic dentist near me, an aesthetic doctor for acne, pigmentation, or anti-aging, or a hair fall 
                    doctor in Tamil Nadu, she stands out as a compassionate and skilled professional dedicated to excellence.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients with healthier smiles, glowing skin, stronger hair, 
                    and renewed confidence through comprehensive, compassionate care.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy Quote */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "For me every consultation is a conversation, every procedure is a promise"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Yuganthi Durai's Philosophy of Care</p>
                  </div>
                  <p>
                    She approaches aesthetics with empathy, safety and artistry to help each person bring out the strength 
                    and confidence they already carry within when they look in the mirror.
                  </p>
                </div>

                {/* Location */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Chennai, Tamil Nadu</h4>
                      <p>Senior Consultant Practice</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience comprehensive dental, skin & hair care with Dr. Yuganthi's personalized approach.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>



        <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default YuganthiDoc
